import packageInfo from "../../../package.json";

const prefix: string = `${packageInfo.name}_`;

const set = (key: string, value: any) => {
    localStorage.setItem(prefix + key, JSON.stringify(value));
};

const get = (key: string): any => {
    return JSON.parse(localStorage.getItem(prefix + key) as string);
};

const remove = (key: string) => {
    localStorage.removeItem(prefix + key);
};

const removeAll = () => {
    for (const key of getKeys()) {
        localStorage.removeItem(key);
    }
};

const getAll = () => {
    const map: { [x: string]: any } = {};

    for (const key of getKeys()) {
        try {
            map[key] = JSON.parse(localStorage.getItem(key) as string);
        } catch (e: any) {
            console.error(e);

            map[key] = e.message;
        }
    }

    return map;
};

const getKeys = () => {
    return Object.keys(localStorage);
};

const storage = {
    set,
    get,
    remove,
    removeAll,
    getAll,
    getKeys,
};

export default storage;
